import { clientI18n } from '../ClientI18n.ts';
import { GameColor } from '@colonist/ui-game';
import { createSpanIn } from '../ui_utils/DomUtils.ts';
import { UIUtilsChat } from './UIUtilsChat.ts';
export class UIChatPostText {
    createTextInPost(post) {
        if (this.shouldColorAndBoldUsernames) this.text = UIUtilsChat.colorAndBoldUsernames(this.text);
        this.text = UIUtilsChat.replaceKeywordsWithImages(this.text);
        this.prefixWithUsername();
        const messageSpanClassName = this.italics ? ' italics' : '';
        const contentSpan = createSpanIn(post, messageSpanClassName, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: this.text,
                interpolation: {
                    escapeValue: false
                }
            }
        });
        this.handleVPText(contentSpan);
    }
    prefixWithUsername() {
        if (this.username == undefined || this.isLog) return;
        this.text = UIUtilsChat.getHighlightedUsername(this.username) + ': ' + this.text;
    }
    handleVPText(contentSpan) {
        const vpText = contentSpan.getElementsByClassName('vp-text')[0];
        if (vpText == undefined) return;
        vpText.style.color = UIUtilsChat.getTextColor('' + this.username, GameColor.getColor(this.textColor));
    }
    constructor(post, chatData, textColor, isLog){
        this.text = clientI18n.t(chatData.text.key, chatData.text.options);
        this.username = chatData.username;
        this.italics = chatData.italics == true;
        this.shouldColorAndBoldUsernames = chatData.colorAndBoldUsernames == true;
        this.textColor = textColor;
        this.isLog = isLog;
        this.createTextInPost(post);
    }
}
